/**
 * Factory function to create bulk import modal handlers
 * @param {Object} params - Parameters object
 * @param {Function} params.setIsBulkImportModalOpen - Setter for modal open state
 * @param {Function} params.setBulkImportFile - Setter for file state
 * @param {Function} params.setBulkImportFileName - Setter for file name state
 * @returns {Object} Object containing modal handlers
 */
export const createBulkImportModalHelpers = ({
  setIsBulkImportModalOpen,
  setBulkImportFile,
  setBulkImportFileName,
}) => {
  const handleBulkImportOpenModal = () => {
    try {
      setIsBulkImportModalOpen(true);
    } catch (error) {
      console.error("handleBulkImportOpenModal: Unexpected error", error);
    }
  };

  const handleBulkImportCloseModal = () => {
    try {
      setBulkImportFile(null);
      setBulkImportFileName("");
      setIsBulkImportModalOpen(false);
    } catch (error) {
      console.error("handleBulkImportCloseModal: Unexpected error", error);
    }
  };

  return {
    handleBulkImportOpenModal,
    handleBulkImportCloseModal,
  };
};
